import { connect } from 'react-redux'
import Globals from '../../../globals'
import * as action from '../../state/detail/action'
import * as selector from '../../state/detail/selector'
import { callNumber } from '../../../sipgate/state/action'
import SalesOrderCustomer from '../detail/SalesOrderCustomer'


const mapStateToProps = (state, props) => {
    return {
        salesOrderCustomer: selector.selectSalesOrderCustomer(state),
        salutationList: Globals.selector.selectSalutationList(state),
        contact: selector.selectSalesOrderCustomerContact(state),
        error: selector.selectAPIError(state)
    }
}

const mapDispatchToProps = {
    callNumber,
    changeSalesOrderCustomer: action.changeSalesOrderCustomer,
    saveSalesOrderCustomer: action.saveSalesOrderCustomer,
    changeCustomerContact: action.changeSalesOrderCustomerContact,
    saveCustomerContact: action.saveSalesOrderCustomerContact,
    hydrateContact: action.hydrateSalesOrderCustomerContact
}

export default connect(mapStateToProps, mapDispatchToProps)(SalesOrderCustomer)



// WEBPACK FOOTER //
// ./src/modules/sales-order/component/task-widget/SalesOrderCustomerWidgetContainer.js